export const mangaCategories = [
  { slug: "rexue", name: "热血漫画", icon: "ri-fire-line", description: "燃爆青春的热血战斗漫画，每一页都让人肾上腺素飙升" },
  { slug: "lianai", name: "恋爱漫画", icon: "ri-heart-line", description: "甜蜜浪漫的恋爱故事，心动不已的纯爱物语" },
  { slug: "xuanhuan", name: "玄幻漫画", icon: "ri-magic-line", description: "奇幻瑰丽的异世界冒险，超乎想象的玄幻之旅" },
  { slug: "danmei", name: "耽美漫画", icon: "ri-star-line", description: "唯美细腻的耽美佳作，感受不一样的情感世界" },
  { slug: "kongbu", name: "恐怖漫画", icon: "ri-ghost-line", description: "惊悚刺激的恐怖悬疑，挑战你的胆量极限" },
  { slug: "gaoxiao", name: "搞笑漫画", icon: "ri-emotion-laugh-line", description: "轻松幽默的爆笑日常，治愈你的不开心" },
  { slug: "hanman", name: "无遮挡韩漫", icon: "ri-eye-line", description: "原汁原味韩国漫画，无遮挡完整呈现，极致阅读体验" },
  { slug: "guoman", name: "国产漫画", icon: "ri-flag-line", description: "优秀的国产原创漫画，支持国漫崛起" },
  { slug: "riman", name: "日本漫画", icon: "ri-sun-line", description: "经典日漫连载，人气日漫一网打尽" },
];

export const mangaList = [
  {
    id: 1,
    title: "斗破苍穹",
    author: "天蚕土豆",
    category: "xuanhuan",
    status: "连载中",
    latestChapter: "第587话 萧炎大战魂殿",
    updateTime: "2小时前",
    rating: 9.5,
    views: 12800000,
    description: "天才少年萧炎在创造了家族空前绝后的修炼纪录后突然成了废人，种种打击接踵而至。就在他即将绝望之时，一缕灵魂从他手上的戒指里浮现，一扇全新的大门正在开启...",
    coverSeq: "dpcq-cover-01",
    coverQuery: "Epic fantasy manga cover art featuring a young martial artist with black hair in flowing red robes wielding mystical flames, dramatic lighting with golden and crimson tones, clean simple background with subtle smoke effects, highly detailed illustration style, dynamic composition, 8k quality",
  },
  {
    id: 2,
    title: "偷偷藏不住",
    author: "竹已",
    category: "lianai",
    status: "连载中",
    latestChapter: "第203话 终于等到你",
    updateTime: "1小时前",
    rating: 9.7,
    views: 15600000,
    description: "十三岁那年，桑稚偷偷喜欢上了一个人。那个人的模样，她记了好多年。后来，她终于等到那个人回头看她。",
    coverSeq: "ttczb-cover-02",
    coverQuery: "Romantic manga cover illustration featuring a young couple in school uniforms sharing a tender moment under cherry blossom trees, soft pink and warm golden lighting, dreamy atmosphere, clean simple white background with scattered petals, beautiful anime art style, delicate details",
  },
  {
    id: 3,
    title: "全职高手",
    author: "蝴蝶蓝",
    category: "rexue",
    status: "已完结",
    latestChapter: "第1728话 荣耀永不散场",
    updateTime: "3天前",
    rating: 9.8,
    views: 23500000,
    description: "网游荣耀中被誉为教科书级别的顶尖高手叶修，因为种种原因遭到俱乐部的驱逐，离开职业圈的他寄身于一家网吧成了一个小小的网管。但是，拥有十年游戏经验的他，在荣耀新开的第十区重新投入了游戏，带着对往昔的回忆和一把未完成的自制银武，开始了重返巅峰之路。",
    coverSeq: "qzyx-cover-03",
    coverQuery: "Action manga cover art featuring a cool silver-haired gamer wearing a black jacket with intense focused expression, neon gaming aesthetics with blue and orange accents, dynamic esports atmosphere, clean dark background with subtle digital particles, high contrast illustration, sharp detailed linework",
  },
  {
    id: 4,
    title: "天官赐福",
    author: "墨香铜臭",
    category: "danmei",
    status: "连载中",
    latestChapter: "第156话 花城现身",
    updateTime: "5小时前",
    rating: 9.6,
    views: 18900000,
    description: "八百年前，谢怜是金枝玉叶的太子殿下，风光无限的天之骄子。八百年后，谢怜第三次飞升，成了一个倒霉透顶的三界笑柄。而当年那位名震四方的绝境鬼王花城，却悄然而至...",
    coverSeq: "tgcf-cover-04",
    coverQuery: "Elegant Chinese fantasy manga cover featuring a celestial being in flowing white and red silk robes with long dark hair, surrounded by floating flower petals and butterflies, ethereal golden light, clean soft gradient background, exquisite traditional Chinese art style blended with modern manga aesthetics",
  },
  {
    id: 5,
    title: "我独自升级",
    author: "Chugong",
    category: "hanman",
    status: "连载中",
    latestChapter: "第179话 最终觉醒",
    updateTime: "30分钟前",
    rating: 9.9,
    views: 28700000,
    description: "被称为人类最弱兵器的成振宇，在一次生死攸关的双重 dungeon 中濒临死亡，却意外获得了神秘系统——Player System。从此，他踏上了一条只有他能走的升级之路，成为了独一无二的S级猎人。",
    coverSeq: "wdzsj-cover-05",
    coverQuery: "Korean manhwa cover art featuring a powerful dark-haired hunter with piercing blue eyes in a sleek black combat outfit, surrounded by ethereal blue system interface holograms, dramatic shadow effects, clean dark gradient background, premium manhwa illustration style with sharp details and cinematic lighting",
  },
  {
    id: 6,
    title: "灵笼",
    author: "艺画开天",
    category: "guoman",
    status: "连载中",
    latestChapter: "第89话 灯塔危机",
    updateTime: "1天前",
    rating: 9.3,
    views: 9800000,
    description: "未来末世，人类只能生活在浮空堡垒——灯塔之上。地面被噬极兽占据，人类在生存与秩序的夹缝中艰难求生。",
    coverSeq: "linglong-cover-06",
    coverQuery: "Post-apocalyptic Chinese manga cover featuring a futuristic soldier in mechanical armor standing on a floating fortress, dramatic orange and gray sky with lightning, sci-fi dystopian atmosphere, clean dark industrial background, highly detailed mecha and character design, cinematic composition",
  },
  {
    id: 7,
    title: "魔道祖师",
    author: "墨香铜臭",
    category: "danmei",
    status: "已完结",
    latestChapter: "第258话 忘羡一曲远",
    updateTime: "2周前",
    rating: 9.8,
    views: 31200000,
    description: "前世的魏无羡万人唾骂，声名狼藉。被护持一生的师弟带人端了老巢，纵横一世，死无全尸。十六年后，魏无羡以莫玄羽的身份重归于世，遇到了当年那位雅正端方的蓝忘机...",
    coverSeq: "mdsz-cover-07",
    coverQuery: "Chinese xianxia manga cover depicting two elegant cultivators in black and white robes playing guqin amidst a bamboo forest, ethereal misty atmosphere with soft moonlight, ink wash painting style mixed with detailed character art, serene and mystical mood, clean background",
  },
  {
    id: 8,
    title: "鬼灭之刃",
    author: "吾峠呼世晴",
    category: "riman",
    status: "已完结",
    latestChapter: "第205话 漫漫人生",
    updateTime: "1个月前",
    rating: 9.7,
    views: 27800000,
    description: "大正时期，卖炭少年炭治郎一家被鬼杀害，唯一幸存的妹妹祢豆子却变成了鬼。为了寻找让妹妹变回人类的方法，炭治郎踏上了斩鬼之旅。",
    coverSeq: "gmzr-cover-08",
    coverQuery: "Japanese manga cover art featuring a determined young swordsman with burgundy hair and hanafuda earrings holding a blue nichirin blade, traditional Taisho era aesthetic, water breathing effect in turquoise, clean dark background with subtle wave patterns, iconic shonen art style",
  },
  {
    id: 9,
    title: "甜美的咬痕",
    author: "锐思+伊凯",
    category: "lianai",
    status: "连载中",
    latestChapter: "第312话 永恒之约",
    updateTime: "4小时前",
    rating: 9.4,
    views: 14500000,
    description: "杜小莘在吸血鬼与人类共存的现代都市中，与冷酷高傲的吸血鬼贵族凌宇辰展开了一段跨越种族的禁忌之恋。",
    coverSeq: "tmdyh-cover-09",
    coverQuery: "Romantic vampire manga cover featuring a handsome male vampire with crimson eyes in elegant black attire and a gentle human girl in white dress, gothic rose garden background, moonlight atmosphere, deep red and silver color palette, exquisite shoujo art style with intricate details",
  },
  {
    id: 10,
    title: "完美世界",
    author: "辰东",
    category: "xuanhuan",
    status: "连载中",
    latestChapter: "第421话 石昊破境",
    updateTime: "6小时前",
    rating: 9.5,
    views: 11200000,
    description: "一粒尘可填海，一根草斩尽日月星辰，弹指间天翻地覆。群雄并起，万族林立，诸圣争霸，乱天动地。一个少年从大荒中走出，一切从这里开始...",
    coverSeq: "wmsj-cover-10",
    coverQuery: "Epic xianxia manga cover art featuring a young cultivator with flowing long hair standing atop a mountain peak, ancient mythical beasts in the clouds, golden sunrise lighting, breathtaking fantasy landscape background, grand scale, traditional Chinese ink painting influences with modern manga rendering",
  },
  {
    id: 11,
    title: "咒术回战",
    author: "芥见下下",
    category: "riman",
    status: "连载中",
    latestChapter: "第257话 最终决战",
    updateTime: "8小时前",
    rating: 9.6,
    views: 20100000,
    description: "高中生虎杖悠仁吞下了诅咒之王两面宿傩的手指，从此踏入了咒术师的世界。在不断与诅咒战斗的过程中，他逐渐理解了什么是正确的死亡。",
    coverSeq: "zshz-cover-11",
    coverQuery: "Dark fantasy manga cover featuring a spiky pink-haired teenager with supernatural cursed energy aura in purple and black, intense battle-ready pose, urban Japanese cityscape at night, dramatic lighting with neon accents, bold dynamic shonen art style with sharp angular linework",
  },
  {
    id: 12,
    title: "女神降临",
    author: "Yaongyi",
    category: "hanman",
    status: "连载中",
    latestChapter: "第234话 真心告白",
    updateTime: "2小时前",
    rating: 9.3,
    views: 16700000,
    description: "通过化妆技巧从丑小鸭变身校园女神的任朱静，在两个完美男神之间展开了一段令人心动的三角恋。",
    coverSeq: "nsjl-cover-12",
    coverQuery: "Korean romance manhwa cover featuring a beautiful girl with flawless makeup transformation and two handsome male leads, modern Korean high school setting, soft pastel pink and coral tones, glamorous beauty aesthetic, clean bright background, premium webtoon illustration style",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "漫画迷小王",
    avatar: "ri-user-3-line",
    platform: "汗汗漫画忠实用户",
    content: "汗汗漫画真的是我用过更新最快的漫画平台！每次新章节一出来就能看到，比别的平台快太多了。画质清晰，加载流畅，看韩漫完全无遮挡，体验拉满。已经推荐给身边所有喜欢看漫画的朋友了！",
    rating: 5,
  },
  {
    id: 2,
    name: "二次元少女琳",
    avatar: "ri-user-3-line",
    platform: "资深漫画读者",
    content: "作为一个追了十几年漫画的老读者，汗汗漫画的更新速度确实惊艳到我了。收藏的每部漫画都是第一时间更新，而且分类做得特别细致，找漫画超方便。界面也简洁好看，没有乱七八糟的广告，良心平台！",
    rating: 5,
  },
  {
    id: 3,
    name: "深夜追漫人",
    avatar: "ri-user-3-line",
    platform: "VIP会员",
    content: "每天晚上睡前必刷汗汗漫画，韩漫资源真的全！之前在其他平台找了好久都找不到的韩漫这里都有，而且无遮挡无删减。阅读器体验也一级棒，翻页顺滑，放大缩小都很流畅，真心推荐！",
    rating: 5,
  },
];

export const hotManga = [mangaList[4], mangaList[0], mangaList[6]];

export const latestManga = [mangaList[4], mangaList[1], mangaList[0], mangaList[8], mangaList[11], mangaList[10], mangaList[5], mangaList[2]];